import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';

// Import schemas from generated
const { UpdateFirestoreResponse, CreateUpdateDto } = schemas;

// Re-export schemas for consumers
export const UpdateResponseSchema = UpdateFirestoreResponse;
export const CreateUpdateSchema = CreateUpdateDto;

// Type exports
export type UpdateResponse = z.infer<typeof UpdateResponseSchema>;
export type CreateUpdate = z.infer<typeof CreateUpdateSchema>;

// API factory function
export function createUpdatesApi(client: TypedApiClient) {
  return {
    getUpdates: (params?: {
      startDate?: string;
      endDate?: string;
      limit?: number;
      offset?: number;
    }): Promise<UpdateResponse[]> => {
      return client.get('/updates', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(UpdateResponseSchema),
      });
    },

    createUpdate: (data: CreateUpdate): Promise<UpdateResponse> => {
      return client.post('/updates', {
        data,
        requestSchema: CreateUpdateSchema,
        responseSchema: UpdateResponseSchema,
      });
    },
  };
}
